import { type Center } from '../../types/appointments';

export const getCenterLines = (
  center: Center | undefined,
  isRemoteAppointment: boolean,
  remoteLabel: string
): { name: string; address?: string } => {
  if (isRemoteAppointment) {
    return { name: remoteLabel };
  }

  if (!center) {
    return { name: '' };
  }

  const name = [center.city, center.name].filter(Boolean).join(' - ');
  const address = [center.address, [center.postalCode, center.city].filter(Boolean).join(' ')]
    .filter(Boolean)
    .join(', ');

  return { name, address };
};
